import * as React from 'react';
import * as main from "../../styles/main.module.scss";
import * as reviews from "./style.module.scss";
export const ReviewsVideo = ({ courseName, vidSrc, data }) => {
  const swiperEl = React.useRef();
  React.useEffect(() => {
    if (swiperEl.current) {
      Object.assign(swiperEl.current, {
        slidesPerView: 1,
        spaceBetween: 30,
        autoHeight: true,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
      swiperEl.current.initialize();
    }
  }, []);
  return (
    <section className={reviews.reviews}>
      <div className="container" style={{position: "unset"}}>
        <h2 className={main.titleH2}>Отзывы участников мини-группы курса &laquo;{ courseName }&raquo;:</h2>

        <div className={reviews.reviews__wrapper}>
          <div className={reviews.reviews__videoBg}>
            <div style={{position:"relative",paddingTop:"56.25%"}}>
              <iframe
                className={reviews.reviews__videoFrame}
                width={"560px"}
                height={"315px"}
                src={ vidSrc }
                title={`Отзыв о кураторском сопровождении Курса ${ courseName }`}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>

          <swiper-wrapper class={reviews.reviews__swiper}>
            <swiper-container
              class={reviews.reviews__container}
              ref={swiperEl}
              init="false"
            >
              {
                data.map((elem, index) => (
                  <swiper-slide class={reviews.reviews__slide} key={index}>
                    <p className={reviews.reviews__name}>{elem.author}</p>
                    <p className={reviews.reviews__text}>{elem.text}</p>
                  </swiper-slide>
                ))
              }
            </swiper-container>
            <div className={reviews.reviews__nav}>
              <button
                aria-label="swiper-button-prev"
                className={`swiper-button-prev ${reviews.swiperButtonNext}`}>
              </button>
              <button
                aria-label="swiper-button-next"
                className={`swiper-button-next ${reviews.swiperButtonPrev}`}>
              </button>
            </div>
          </swiper-wrapper>
        </div>
      </div>
    </section>
  );
};
